import Reveal from "@stimulus-components/reveal"
import { transition } from "tailwindcss-stimulus-components"

const DEFAULT_OPTS = Object.freeze({
  enter: "transition-all ease-in duration-200 overflow-hidden",
  enterFrom: "max-h-[0vh]",
  enterTo: "max-h-[100vh]",
  leave: "transition-all ease-out duration-100 overflow-hidden",
  leaveFrom: "max-h-[100vh]",
  leaveTo: "max-h-[0vh]",
  toggleClass: "hidden"
})

// Connects to data-controller="foldable"
export default class extends Reveal {
  static targets = ["fold", "expand", "scrollTo", "foldBtn", "expandBtn"]
  static values = {
    folded: { type: Boolean, default: true }
  }

  connect() {
    super.connect()
    this.init()
  }

  expand(event) {
    if (!this.foldedValue) { return }
    this._swap_visibility(this.expandTarget, this.foldTarget)
      .then(() => {
        this.foldedValue = false
        const scrollToTarget = this.expandTarget.querySelector(event?.target.dataset.scrollToSelector)
        if (scrollToTarget) {
          this.scrollTo(scrollToTarget)
        }
      })
  }

  fold() {
    if (this.foldedValue) { return }
    this._swap_visibility(this.foldTarget, this.expandTarget)
      .then(() => {
        this.foldedValue = true
      })
  }

  scrollTo(target) {
    target.scrollIntoView({ behavior: "smooth", block: "center" })

    setTimeout(() => {
      target.classList.add("animate-highlight-fade")
      target.addEventListener("animationend", () => {
        target.classList.remove("animate-highlight-fade")
      }, { once: true })
    }, 100)
  }

  init() {
    this.foldedValue = this._is_folded();

    [this.foldTarget, this.expandTarget].map((item) => {
      // 애니메이션 종료 상태를 미리 추가
      if (item.classList.contains(this.class)) {
        transition(item, false, { ...DEFAULT_OPTS, leaveFrom: DEFAULT_OPTS.leaveTo })
      } else {
        transition(item, true, { ...DEFAULT_OPTS, enterFrom: DEFAULT_OPTS.enterTo })
        .then(() => item.classList.remove("max-h-[100vh]"))
      }
    })
  }

  defaultOptions() {
    return DEFAULT_OPTS
  }

  foldedValueChanged() {
    this._sync_button();
    this.element.dispatchEvent(new CustomEvent("foldable:changed", {
      detail: {
        folded: this.foldedValue
      }
    }))
  }

  _sync_button() {
    if (this.foldedValue) {
      this.foldBtnTargets.forEach((item) => item.classList.add("hidden"))
      this.expandBtnTargets.forEach((item) => item.classList.remove("hidden"))
    } else {
      this.foldBtnTargets.forEach((item) => item.classList.remove("hidden"))
      this.expandBtnTargets.forEach((item) => item.classList.add("hidden"))
    }
  }

  _is_folded() {
    if (this.expandTarget.classList.contains(this.class)) {
      return true
    } else {
      return false
    }
  }

  async _swap_visibility(to_show, to_hide) {
    // max-h-[100vh]를 지우는 이유:
    // 100vh가 넘어가는 컨텐츠일수도 있기때문에, 애니메이션이 끝난후 max-h-[100vh] 를 지워준다.
    transition(to_hide, false, DEFAULT_OPTS)
    await transition(to_show, true, DEFAULT_OPTS)
    to_show.classList.remove("max-h-[100vh]")
  }
}
